import React from "react";
import ServiceTemplate from "./ServiceTemplate";
import { Flame } from "lucide-react";

const serviceData = {
  id: "incendie",
  title: "Détection incendie",
  description: "Systèmes de détection et d'extinction automatique",
  icon: Flame,
  image: "/Detectionincendie.jpg", // Updated path
  longDescription: [
    "Nos systèmes de détection incendie assurent une protection optimale de vos locaux et de vos collaborateurs. Nous concevons et installons des solutions conformes aux normes de sécurité les plus strictes.",
    "De la détection précoce à l'extinction automatique, nos systèmes garantissent une réaction rapide et efficace en cas d'incendie.",
  ],
  features: [
    "Détecteurs de fumée intelligents",
    "Centrales de détection incendie",
    "Systèmes d'extinction automatique",
    "Alarmes sonores et visuelles",
    "Plans d'évacuation",
    "Maintenance préventive",
  ],
  benefits: [
    "Protection des personnes et des biens",
    "Conformité aux normes de sécurité",
    "Détection précoce des risques",
    "Intervention rapide",
    "Maintenance régulière assurée",
  ],
};

const DetectionIncendie = () => {
  return <ServiceTemplate service={serviceData} />;
};

export default DetectionIncendie;
